module.exports = __webpack_public_path__ + "img/teacther.41544465.png";